import { useState } from 'react';

import { Company, CompanyService } from '../../../interfaces';
import CompanyInputCard from '../InputComponents/CompanyInputCard';
import { Button } from '@material-tailwind/react';
import { MdCreate } from 'react-icons/md';
import { Waypoint } from 'react-waypoint';

const EditGroupInputCard = (props: {
  companyService: CompanyService;
  saveChangesToExistingCompanyService: any;
}) => {
  const [editedCompany, setEditedCompany] = useState<Company | null>(null);
  const [isButtonFloating, setIsButtonFloating] = useState<boolean>(false);

  /**
   * Function can add the edited company to map, with the companyId as the key, or remove the key-value if there is no change
   * to the company
   * Note: 'companyId' is not used in this function because there can only be editing of 1 company in this component. However this function is structured
   * to take in the same set of parameters as the props of CompanyInputCard component so as to reduce the number of props for the CompanyInputCard component.
   * @param companyId - companyId of the edited company
   * @param editedCompany - Company object containing the edited attribute of an existing company, or undefined if the company is to be removed
   */
  const updateEditedCompany = (companyId: number, editedCompany?: Company) => {
    if (editedCompany) {
      setEditedCompany(editedCompany);
    } else {
      setEditedCompany(null);
    }
  };

  /**
   * Function is run by save changes button, and calls saveChangesToExistingCompanyService function. Function saves edited company (if any).
   */
  const saveChangesForUpdateCompanyOnClick = async () => {
    const isSaved = await props.saveChangesToExistingCompanyService(
      { companyId: props.companyService.companyId },
      {},
      {
        companyToBeUpdated: editedCompany !== null ? editedCompany : undefined,
      }
    );
    // Reset changes if the company changes have been updated successfully
    if (isSaved) {
      setEditedCompany(null);
    }
  };

  return (
    <div className="flex flex-col">
      <Button
        onClick={saveChangesForUpdateCompanyOnClick}
        size="sm"
        color="green"
        className={`${
          isButtonFloating && 'fixed top-20 z-10'
        } SaveChangesButton bg-blue-600 w-fit self-end flex gap-x-1 pt-2 p-2 font-medium h-fit'}`}
      >
        <MdCreate className="self-center" />
        Save Changes
      </Button>
      <Waypoint
        onEnter={() => setIsButtonFloating(false)}
        onLeave={() => setIsButtonFloating(true)}
      />
      <CompanyInputCard
        arrNewCompany={[]}
        companyService={props.companyService}
        companyId={props.companyService.companyId}
        updateCompany={updateEditedCompany}
      />
    </div>
  );
};

export default EditGroupInputCard;
